import React from "react";
import { fmt } from "../crm/crmUtil";

// Immutable version history of one template key; any version can be loaded into the editor as the base of a new one.
export default function TemplateVersions({ versions, onLoad }) {
  if (!versions.length) return null;
  return (
    <section className="border border-erf-borderCream rounded bg-white p-3" aria-labelledby="tpl-ver-title" data-testid="tpl-versions">
      <h3 id="tpl-ver-title" className="text-xs uppercase font-nav text-erf-dark/60 mb-2">Versions (newest first; contracts keep the version they used)</h3>
      <ul className="space-y-2">
        {versions.map((v) => (
          <li key={v.id} className="flex flex-wrap items-center gap-2 text-sm" data-testid={`tpl-version-${v.version}`}>
            <span className="font-semibold">v{v.version}</span>
            <span className="text-erf-dark/60">{fmt(v.created_at)}</span>
            <span className="font-mono text-xs text-erf-dark/60">{(v.sha256 || "").slice(0, 12)}</span>
            {v.note && <span className="break-words min-w-0">· {v.note}</span>}
            <button type="button" onClick={() => onLoad(v)}
              className="min-h-[44px] px-3 rounded-sm border border-erf-borderCream text-xs ml-auto focus-visible:outline focus-visible:outline-2 focus-visible:outline-erf-dark"
              data-testid={`tpl-load-${v.version}`}>Load into editor</button>
          </li>
        ))}
      </ul>
    </section>
  );
}
